import React from "react";
import { IndexLink, Link } from "react-router";
import PropTypes from "prop-types";

import Logo from "../../components/Logo/NexoidDevLogo";
import Search from "../../components/Search/Search";

import "../../styles/_base.scss";

export const PageLayout = ({ children }) => (
  <div className="mainBackgroundFix" style={{ paddingTop: 72, height: "100%" }}>
    {children}
    <div
      style={{
        boxShadow: "0px 0px 20px 3px rgba(0,0,0,0.2)",
        position: "fixed",
        display: "block",
        backgroundColor: "#0f111a",
        padding: 10,
        top: 0,
        left: 0,
        width: "100%"
      }}
    >
      <div
        style={{
          marginRight: "auto",
          display: "block",
          width: 167,
          height: 52
        }}
      >
        <Link to="/">
          <Logo />
        </Link>
      </div>
      <div
        style={{
          position: "fixed",
          display: "block",
          right: 16,
          top: 16
        }}
      >
        <Search />
      </div>
    </div>
  </div>
);
PageLayout.propTypes = {
  children: PropTypes.node
};

export default PageLayout;



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/PageLayout.js